import { all, takeLatest, put, delay, select } from 'redux-saga/effects';
import { fetchOrderHistoryRequest } from '@modules/orders/core/actions';
import { PlaceOrderSuccess } from '@modules/subscriptions/core/types';
import { fetchOrderScheduleRequest } from '@modules/order-schedule/core/actions';
import { getCustomerSelector } from '@modules/customer/core/selectors';

function* watchPlaceOrderSuccess(action: PlaceOrderSuccess) {
  yield delay(3000);

  const subscriptionId = action.payload.subscription.id;
  // Pass the cached Shopify customer id when available so the API skips its
  // own Loop /customer round-trip in /order_history.
  const customer: ICustomer | null = yield select(getCustomerSelector);
  const shopifyCustomerId = customer?.shopifyId;

  yield put(fetchOrderScheduleRequest({ subscriptionId }));
  yield put(fetchOrderHistoryRequest({ subscriptionId, shopifyCustomerId }));
}

export function* rootWatcher() {
  yield all([takeLatest('PLACE_ORDER_SUCCESS', watchPlaceOrderSuccess)]);
}
